import hasTaskGroup from './hasTaskGroup';

const hasTask = (task) => {
  return {
    task: Object.assign(
      { ...task },
      hasTaskGroup(task.taskGroup),
    ),
  };
};

export default hasTask;
